"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractProducts = exports.extractDisclosures = exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireWildcard(require("react"));
var _pfComponentLibrary = require("@pf-loan-funnel/pf-component-library");
var _api = require("./api");
var _constants = require("./constants");
var _util = require("./util");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// eslint-disable-next-line import/no-unresolved

var getMinMaxAPR = function getMinMaxAPR() {
  var offers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var aprs = offers.map(function (_ref) {
    var apr = _ref.apr;
    return +apr;
  });
  return {
    min: Math.min.apply(Math, (0, _toConsumableArray2.default)(aprs)),
    max: Math.max.apply(Math, (0, _toConsumableArray2.default)(aprs))
  };
};
var parseTitle = function parseTitle(_ref2) {
  var id = _ref2.id,
    title = _ref2.title,
    offers = _ref2.offers;
  if (id === 'LCFRP') {
    var _getMinMaxAPR = getMinMaxAPR(offers),
      min = _getMinMaxAPR.min,
      max = _getMinMaxAPR.max;
    return "".concat(min, "% - ").concat(max, "% APR");
  }
  if (!title.includes('(')) return title;
  return title.substring(0, title.indexOf('(')).trimEnd();
};

/*
  This should be handled by the backend. Backend sends HTML strings.
  It's a huge security risk to interpret the HTML strings directly as HTML
  so we are doing this workaround.
*/
var replaceHTMLChars = function replaceHTMLChars(str) {
  if (!str) return str;
  var mapping = [[/&mdash;/g, '—'], [/<br\/>/g, '']];
  return mapping.reduce(function (acc, _ref3) {
    var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
      html = _ref4[0],
      equivalent = _ref4[1];
    return acc.replace(html, equivalent);
  }, str);
};
var getSuperScript = function getSuperScript(planTitle, product) {
  return ['PRP', 'NI'].includes(product.id.toUpperCase()) ? "".concat(product.productDisclosureSup) : "".concat(planTitle.endsWith('APR') ? '** ' : '').concat(product.productDisclosureSup);
};
var extractProducts = exports.extractProducts = function extractProducts(products) {
  var showBadge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var expiryDate = arguments.length > 2 ? arguments[2] : undefined;
  var noOfDaysToExpiry = arguments.length > 3 ? arguments[3] : undefined;
  var _ref5 = showBadge ? (0, _util.getIDsToBadge)(products) : {},
    lowestPaymentID = _ref5.lowestPaymentID,
    lowestRateID = _ref5.lowestRateID,
    lowestBothID = _ref5.lowestBothID;
  return products.map(function (product) {
    var _product$id, _product$id3;
    var planTitle = parseTitle(product);
    return {
      id: (_product$id = product.id) === null || _product$id === void 0 ? void 0 : _product$id.toUpperCase(),
      offerItems: product.offers.map(function (offer, idx) {
        var _product$id2;
        var isLowestPayment = lowestPaymentID === offer.id;
        var isLowestRates = lowestRateID === offer.id;
        var isLowestBoth = lowestBothID === offer.id;
        var badge = isLowestBoth ? 'LOWEST PAYMENT & BEST RATE' : isLowestPayment ? 'LOWEST PAYMENT' : isLowestRates ? 'BEST RATE' : undefined;
        var color = isLowestBoth || isLowestRates ? 'blue' : isLowestPayment ? 'green' : undefined;
        return {
          id: offer.id,
          content: /*#__PURE__*/_react.default.createElement(_pfComponentLibrary.Button.Radio, {
            value: "".concat((_product$id2 = product.id) === null || _product$id2 === void 0 ? void 0 : _product$id2.toUpperCase(), "-").concat(offer.id),
            text: "".concat(offer.monthlyPayment, "/mo"),
            supplementalText: offer.showSuggestedText ? ' (suggested)' : '',
            superscript: product.detailedPlanDisclosureSup,
            subText: "for ".concat(offer.term, " Months at ").concat(offer.apr, "% APR"),
            dataId: "".concat(product.id, "-").concat(idx)
          }),
          cardCss: {
            '& .pf-radio': {
              marginTop: 3,
              '@desktop': {
                marginTop: 11
              }
            }
          },
          badge: badge,
          color: color
        };
      }),
      titleDetails: {
        amount: product.amount,
        title: product.type,
        bank: product.bank,
        plan: {
          title: planTitle,
          subTitle: _constants.subtitleMapping.get(product.product),
          superScript: getSuperScript(planTitle, product)
        },
        subTitle: ((_product$id3 = product.id) === null || _product$id3 === void 0 ? void 0 : _product$id3.toUpperCase()) === 'LCTNI' ? 'Pay no interest for the entire duration of the loan' : replaceHTMLChars(product.description),
        expiryDate: expiryDate,
        noOfDaysToExpiry: noOfDaysToExpiry
      },
      counterOffer: product.counterOffer,
      counterMessage: product.counterMessage
    };
  });
};
var extractDisclosures = exports.extractDisclosures = function extractDisclosures(disclosures) {
  var parser = new DOMParser();
  return Object.values(disclosures).map(function (disclosure) {
    var _html$getElementsByTa, _html$getElementsByTa2, _html$getElementsByTa3, _html$getElementsByTa4;
    var html = parser.parseFromString(disclosure, 'text/html');
    var superscript = ((_html$getElementsByTa = html.getElementsByTagName('sup')[0]) === null || _html$getElementsByTa === void 0 ? void 0 : _html$getElementsByTa.innerText) || ((_html$getElementsByTa2 = html.getElementsByTagName('strong')[0]) === null || _html$getElementsByTa2 === void 0 ? void 0 : _html$getElementsByTa2.innerText);
    var heading = (_html$getElementsByTa3 = html.getElementsByTagName('u')[0]) === null || _html$getElementsByTa3 === void 0 ? void 0 : _html$getElementsByTa3.innerText;
    var description = (_html$getElementsByTa4 = html.getElementsByTagName('p')[0]) === null || _html$getElementsByTa4 === void 0 || (_html$getElementsByTa4 = _html$getElementsByTa4.innerText) === null || _html$getElementsByTa4 === void 0 ? void 0 : _html$getElementsByTa4.replace(superscript, '').replace(heading, '');
    return {
      heading: heading,
      description: description,
      superscript: superscript
    };
  });
};
var useSelectPlan = function useSelectPlan(applicationID, clientID, postSelectedOfferURL, successCallback) {
  var _useState = (0, _react.useState)(_constants.AjaxStatus.Initial),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  return {
    status: status,
    submitForm: function () {
      var _submitForm = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(selectedOffer, offerProductsForTracking, variation, badges) {
        var _selectedOffer$split, _selectedOffer$split2, productType, selectedOfferId, isADSHardPullCounterOffer, _yield$post, data;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              setStatus(_constants.AjaxStatus.InProgress);
              _selectedOffer$split = selectedOffer.split('-'), _selectedOffer$split2 = (0, _slicedToArray2.default)(_selectedOffer$split, 2), productType = _selectedOffer$split2[0], selectedOfferId = _selectedOffer$split2[1];
              isADSHardPullCounterOffer = variation === 'ADS_HARD_PULL_COUNTER';
              _context.prev = 3;
              _context.next = 6;
              return (0, _api.post)("".concat(postSelectedOfferURL, "?id=").concat(applicationID, "&clientId=").concat(clientID), {
                id: applicationID,
                selectedOfferId: selectedOfferId,
                badges: badges,
                offerProductsForTracking: offerProductsForTracking,
                prodType: _constants.prodTypeMapping.get(productType.toUpperCase()),
                partialChange: !isADSHardPullCounterOffer,
                counterADS: isADSHardPullCounterOffer || undefined,
                completeLoanProcess: isADSHardPullCounterOffer || undefined
              });
            case 6:
              _yield$post = _context.sent;
              data = _yield$post.data;
              setStatus(_constants.AjaxStatus.Success);
              successCallback(data);
              _context.next = 15;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);
              setStatus(_constants.AjaxStatus.Error);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 12]]);
      }));
      function submitForm(_x, _x2, _x3, _x4) {
        return _submitForm.apply(this, arguments);
      }
      return submitForm;
    }(),
    getVariation: function getVariation(offers, completeLoanProcess) {
      if (offers !== null && offers !== void 0 && offers.products.length) {
        if (completeLoanProcess && offers.offerDeclined && !offers.isLCBDeclined) {
          return 'ADS_HARD_PULL_DECLINE';
        }
        if (completeLoanProcess && offers.counterADS && !offers.adsOfferNotAvailable) {
          return 'ADS_HARD_PULL_COUNTER';
        }
        if (!offers.counterADS || offers.counterADS && !completeLoanProcess) {
          return 'SUCCESS';
        }
      }
      if (offers.frozenFlag) {
        return 'DECLINE_FROZEN';
      }
      return 'FULL_DECLINE';
    }
  };
};
var _default = exports.default = useSelectPlan;
